import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Badge, Nav, NavItem, NavLink as RsNavLink, NavbarBrand, Label } from "reactstrap";
import classNames from "classnames";
import nav from "./_nav";
import cross from "../../../../public/svg/x-symbol-svgrepo-com.svg";
import MediaQuery from "react-responsive";
import BadgeIcon from "../../Layout/BadgeIcon/BadgeIcon";
import { useSelector, useDispatch } from "react-redux";
import { getCounters } from "../../../reducers/selectors";
import { signOut } from "../../../actions/auth";
import { UserSelector } from "../../UserSelector/UserSelector";
import NavbarToggler from "reactstrap/lib/NavbarToggler";
import GenericButton from "../../UI/Button/Button";
import { currentAccountSet, personInfoSet } from "../../../actions/entities";
import { getCurrentAccount, getSavedPersonInfo } from "../../../reducers/selectors";
import { fetchGetAccounts } from "../../../services/api/accounts";
import { getPersonInfo } from "../../../services/api/person";
import { Prompt } from "react-router-dom";
import { MyData } from "../MyData/MyData";

import style from "./Sidebar.scss";

import menuIcon from "../../../../public/svg/menu.svg";

const Sidebar = () => {
  const dispatch = useDispatch();
  const counters = useSelector(getCounters);
  const personInfo = useSelector(getSavedPersonInfo);
  const [showMyData, setShowMyData] = useState(false);
  const currentAccount = useSelector(getCurrentAccount);
  const [isAppMobile, setIsAppMobile] = useState(false);

  useEffect(() => {
    setIsAppMobile(window.___APP_CONFIG___.APP_MOBILE);
  }, []);

  useEffect(() => {
    getPersonInfo()
      .then(({ response }) => {
        dispatch(personInfoSet(response.personInfo));
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    fetchGetAccounts()
      .then((r) => {
        if (r.response.accounts.length > 0) {
          const context = JSON.parse(sessionStorage.getItem("context") || "{}");
          const parameters = context && context.session && context.session.Parameters;
          const preselectedParam = parameters && parameters.find(function(p) { return p.key === "preselectedAccountId"; });
          const preselectedAccountId = preselectedParam && preselectedParam.value;
          const preselectedAccount = preselectedAccountId
            ? r.response.accounts.find(
                (account) => account.id != null && account.id.toString() === preselectedAccountId.toString(),
              )
            : null;
          handleChangeAccount(preselectedAccount || r.response.accounts[0]);
        } else {
          handleChangeAccount({
            noAccounts: true,
            AccountNumber: 0,
            AccountEmail: "",
            AccountName: "",
            advisorName: "",
            advisorFirstLastName: "",
            advisorEmail: "",
            advisorPhone: "",
          });
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const handleChangeAccount = (newAccount) => {
    dispatch(currentAccountSet({ ...currentAccount, ...newAccount, AccountNumber: newAccount.number }));
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.target.parentElement.classList.toggle("open");
  };

  const activeRoute = (routeName, props) => {
    // return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    return props.location.pathname.indexOf(routeName) > -1
      ? "nav-item nav-dropdown open"
      : "nav-item nav-dropdown";
  };

  const hideMobile = () => {
    if (document.body.classList.contains("sidebar-mobile-show")) {
      document.body.classList.toggle("sidebar-mobile-show");
    }
  };

  const onLogout = () => {
    sessionStorage.clear();
    dispatch(signOut());
  };

  const isActiveItem = (e, url) => {
    return e.pathname === url;
  };

  // todo Sidebar nav secondLevel
  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }

  // badge addon to NavItem
  const badge = (badge) => {
    if (badge) {
      const classes = classNames(badge.class);
      return (
        <Badge className={classes} color={badge.variant}>
          {badge.text}
        </Badge>
      );
    }
  };

  // simple wrapper for nav-title item
  const wrapper = (item) => {
    return item.wrapper && item.wrapper.element
      ? React.createElement(item.wrapper.element, item.wrapper.attributes, item.name)
      : item.name;
  };

  // nav list section title
  const title = (title, key) => {
    const classes = classNames("nav-title", title.class);
    return (
      <li key={key} className={classes}>
        {wrapper(title)}{" "}
      </li>
    );
  };

  // nav list divider
  const divider = (divider, key) => {
    const classes = classNames("divider", divider.class);
    return <li key={key} className={classes}></li>;
  };

  // nav label with nav link
  const navLabel = (item, key) => {
    const classes = {
      item: classNames("hidden-cn", item.class),
      link: classNames("nav-label", item.class ? item.class : ""),
      icon: classNames(
        !item.icon ? "fa fa-circle" : item.icon,
        item.label.variant ? `text-${item.label.variant}` : "",
        item.label.class ? item.label.class : "",
      ),
    };
    return navLink(item, key, classes);
  };

  // nav item with nav link
  const navItem = (item, key) => {
    const classes = {
      item: classNames(item.class),
      link: classNames("nav-link", item.variant ? `nav-link-${item.variant}` : ""),
      icon: classNames(item.icon),
    };
    return navLink(item, key, classes);
  };

  // nav link
  const navLink = (item, key, classes) => {
    const url = item.url ? item.url : "";
    const iconUrl = item.iconUrl ? item.iconUrl : "";

    const onClick = url === "/login" ? onLogout : hideMobile;

    return (
      <React.Fragment>
        <NavItem key={key} className={style.item}>
          {isExternal(url) ? (
            <RsNavLink href={url} className={classes.link} active>
              <span className={style.wrapper}>
                <img src={iconUrl} className={style.iconSvg} />
              </span>
              <span>
                <i className={classes.icon}></i>
                {item.name}
                {badge(item.badge)}
              </span>
            </RsNavLink>
          ) : (
            <NavLink
              to={url}
              className={classes.link}
              activeClassName="active"
              isActive={(tmp, e) => isActiveItem(e, url)}
              onClick={onClick}
            >
              <span>
                <span className={style.wrapper}>
                  <img src={iconUrl} className={style.iconSvg} />
                </span>
                <i className={classes.icon}></i>
                <Label className={style.iconLabels}>{item.name}</Label>

                {badge(item.badge)}
              </span>
            </NavLink>
          )}
          <NavBadge counter={item.counter} />
        </NavItem>
        {item.name == "Autorizaciones" && (
          // <div
          //   className={style.divHrFirst}
          //   style={{ padding: "10px", paddingBottom: "0px", backgroundColor: "#EDEDED" }}
          // >
          //</div>
          <hr className={style.hrItems} />
        )}
      </React.Fragment>
    );
  };

  const NavBadge = ({ counter }) => {
    if (!counter) {
      return null;
    } else {
      const total = +counters[counter] || 0;
      return total === 0 ? null : <BadgeIcon count={total} />;
    }
  };

  // nav dropdown
  const navDropdown = (item, key) => {
    return (
      <li key={key} className={activeRoute(item.url, props)}>
        <a className="nav-link nav-dropdown-toggle" href="#" onClick={handleClick}>
          <i className={item.icon}></i>
          {item.name}
        </a>
        <ul className="nav-dropdown-items">{navList(item.children)}</ul>
      </li>
    );
  };

  // nav type

  const navType = (item, idx) => {
    return item.title
      ? title(item, idx)
      : item.divider
        ? divider(item, idx)
        : item.label
          ? navLabel(item, idx)
          : item.children
            ? navDropdown(item, idx)
            : navItem(item, idx);
  };

  // nav list
  const navList = (items) => {
    return items.map((item, index) => navType(item, index));
  };

  const isExternal = (url) => {
    const link = url ? url.substring(0, 4) : "";
    return link === "http";
  };

  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  };

  const toggleShowMyData = () => {
    setShowMyData((stateMyData) => !stateMyData);
  };

  // sidebar-nav root
  return (
    <div className={!isAppMobile ? `${style.sidebar} sidebar` : "hideElement"}>
      <nav style={{ height: "100%" }} className={`${style.sidebarNav} sidebar-nav`}>
        <MediaQuery minWidth={1023}>
          <div
            style={{
              background: "#27272A",
              display: "flex",
              alignItems: "center",
              paddingTop: "35px",
              justifyContent: "space-around",
            }}
          >
            <img
              id={style.imgLogo}
              src="/svg/SideBarIcons/full-logo-home-white.svg"
              alt="logo"
              style={{ width: "235px", backgroundColor: "#27272A" }}
            />
          </div>
          <div style={{ paddingTop: "6px", paddingBottom: "0px", backgroundColor: "#27272A" }}>
            <hr className={style.hr} />
          </div>
        </MediaQuery>
        <MediaQuery maxWidth={575}>
          <div className={style.mobileSidebarHeader}>
            <span className={style.hambMenuLogo}>
              <NavbarToggler
                className={`${style.navToggler} d-md-down-none`}
                onClick={(e) => {
                  mobileSidebarToggle(e);
                }}
              >
                <img className={style.hambIcon} src={cross} alt="hamburger menu" />
              </NavbarToggler>
            </span>

            {/* <img className={style.logo} src="/svg/SideBarIcons/logo-home.svg" alt="Logo" />
            <p className={style.dummyDiv}></p> */}
          </div>
          <div
            //id={style.imgLogo}
            src="/svg/SideBarIcons/full-logo-home-white.svg"
            alt="logo"
            style={{
              backgroundColor: "#27272A",
              display: "flex",
              justifyContent: "start",
              margin: "0 auto",
            }}
          >
            <img
              id={style.imgLogo}
              src="/svg/SideBarIcons/full-logo-home-white.svg"
              alt="logo"
              style={{ width: "250px", backgroundColor: "#27272A" }}
            />
          </div>
          <div className={style.hrDiv1} style={{ backgroundColor: "#27272A" }}>
            <hr className={style.hr} />
          </div>
        </MediaQuery>

        {/* <MediaQuery maxWidth={575}>
            <UserSelector isInNavbar />
          </MediaQuery> */}
        <MediaQuery minWidth={576}>
          <span id={style.mobileSidebarHeader}>
            <img
              src={cross}
              alt="cross"
              className={style.cross}
              onClick={(e) => {
                mobileSidebarToggle(e);
              }}
            />
            <div
              id={style.imgLogo}
              src="/svg/SideBarIcons/logo-home.svg"
              alt="logo"
              style={{ backgroundColor: "#EDEDED", display: "flex" }}
            >
              <img
                id={style.imgLogo}
                src="/svg/SideBarIcons/logo-home.svg"
                alt="logo"
                style={{ width: "100px", backgroundColor: "#EDEDED" }}
              />
              <div className={style.verticaLine}></div>
              <Label className={style.logoLabel}>Casa de Bolsa</Label>
            </div>
            <div className={style.hrDiv} style={{ backgroundColor: "#EDEDED" }}>
              <hr className={style.hr} />
            </div>
          </span>
        </MediaQuery>

        <div className={style.orangeBackground} style={{ justifyContent: "space-between" }}>
          <Nav className={style.nav} id="navSidebar">
            {navList(nav.items)}
          </Nav>
          <div className={style.lastDiv}>
            {/* <div className={style.asesor}>
              <Label style={{ fontWeight: 500, color: "#57534E" }}>Mi asesor</Label>
              <Label>
                {currentAccount.advisorName}
                {currentAccount.advisorFirstLastName}
              </Label>
              <Label>{currentAccount.advisorPhone}</Label>
            </div> */}
            <MediaQuery maxWidth={320}>
              <div className={style.hrDiv}>
                <hr className={style.hr} />
              </div>
              <GenericButton
                width={"100%"}
                // position={"absolute"}
                //bottom={"2px"}
                label={"Mi cuenta"}
                padding={"12px 16px"}
                border={"1px solid #E7E5E4"}
                textColor={"#79716B"}
                font-weight={600}
                backgroundColor={"#FFFF"}
                className={style.myAccountButton}
                lineHeight={"24px"}
                handleClick={toggleShowMyData}
                iconSvg={[
                  { width: "7px", item: "../../svg/SideBarIcons/green-dot.svg" },
                  { width: "20px", item: "../../svg/SideBarIcons/user.svg" },
                ]}
                style={{ margin: "0 auto", width: 264 }}
              ></GenericButton>
            </MediaQuery>
            <MediaQuery minWidth={321} maxWidth={575}>
              <div className={style.hrDiv}>
                <hr className={style.hr} />
              </div>
              <GenericButton
                width={"100%"}
                // position={"absolute"}
                //bottom={"2px"}
                label={"Mi cuenta"}
                padding={"12px 16px"}
                border={"1px solid #3F3F46"}
                textColor={"#FAFAFA"}
                fontWeight={600}
                className={style.myAccountButton}
                backgroundColor={"#3F3F46"}
                lineHeight={"24px"}
                handleClick={toggleShowMyData}
                iconSvg={[
                  { width: "7px", item: "../../svg/SideBarIcons/green-dot.svg" },
                  { width: "20px", item: "../../svg/SideBarIcons/user.svg" },
                ]}
                style={{ margin: "0 auto", width: 264 }}
              ></GenericButton>
            </MediaQuery>
            <MediaQuery minWidth={576}>
              <div className={style.hrDiv}>
                <hr className={style.hr} />
              </div>
              {/* <Link to="/myData"> */}
              <div className={style.accountWrap}>
                <GenericButton
                  width={"312px"}
                  // position={"absolute"}
                  //bottom={"60px"}
                  label={"Mi cuenta"}
                  padding={"12px 16px"}
                  className={style.myAccountButton}
                  border={"1px solid #E7E5E4"}
                  textColor={"#79716B"}
                  font-weight={600}
                  backgroundColor={"#FFFF"}
                  lineHeight={"24px"}
                  handleClick={toggleShowMyData}
                  iconSvg={[
                    { width: "7px", item: "../../svg/SideBarIcons/green-dot.svg" },
                    { width: "20px", item: "../../svg/SideBarIcons/user.svg" },
                  ]}
                  style={{ margin: "0 auto", width: 264 }}
                ></GenericButton>
              </div>

              {/* </Link> */}
            </MediaQuery>
          </div>
        </div>
      </nav>
      <Prompt
        when={showMyData}
        message={(location) => {
          // Ejecutar la función personalizada antes de la navegación hacia atrás
          toggleShowMyData();
          // No permitir la navegación hacia atrás
          return false;
        }}
      />
      {showMyData && <MyData toggleMyData={toggleShowMyData} />}
    </div>
  );
};

export default Sidebar;
